









import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "OperationInstruction",
})

export default class OperationInstruction extends Vue {
    @Prop({
        type: Number,
        default: 0
    }) left!: number
    get msCmdTip() {
        return this.$store.state.msCmdTip
    } 
}
